import { Box } from '@mui/material';
import DataCard from './DataCard';
import KPI from './KPI';

export default function DetailedKPI(
  props: DetailedKPIPoint & { useDataCardWrapper?: boolean },
) {
  const { main, secondary, tertiary, useDataCardWrapper = true } = props;
  const Wrapper = useDataCardWrapper ? DataCard : Box;

  const mainSize: KPISize = secondary || tertiary ? 'medium' : 'large';
  const otherSize: KPISize = secondary || tertiary ? 'small' : 'medium';

  return (
    <Wrapper
      sx={[
        { container: 'kpi / inline-size', height: '100%' },
        !useDataCardWrapper && { width: '100%' },
      ]}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-around',
          gap: 1,
          padding: 1.5,
          alignItems: 'center',
          height: '100%',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          '@container (width < 12rem)': {
            flexDirection: 'column',
          },
        }}
      >
        <KPI main size={mainSize} {...main} />
        {secondary ? <KPI size={otherSize} {...secondary} /> : null}
        {tertiary ? <KPI size={otherSize} {...tertiary} /> : null}
      </Box>
    </Wrapper>
  );
}
